module.exports = "/_next/static/images/za-b2f370d401fe675c820947b81c67843e.svg";